// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2yrAB","content":"LoadingAlert_content__2tIDw"};